import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const PictureIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.496 13.488L5.016 18H18.984L14.496 12L11.016 16.488L8.496 13.488ZM21 18.984C21 19.528 20.8 20 20.4 20.4C20 20.8 19.528 21 18.984 21H5.016C4.472 21 4 20.8 3.6 20.4C3.2 20 3 19.528 3 18.984V5.016C3 4.472 3.2 4 3.6 3.6C4 3.2 4.472 3 5.016 3H18.984C19.528 3 20 3.2 20.4 3.6C20.8 4 21 4.472 21 5.016V18.984Z'
                fill='currentColor'
            />
        </>
    ),
})

PictureIcon.displayName = 'PictureIcon'
